import Cookies from 'js-cookie';


export function getStorage(key)
{
    if(localStorage.getItem(key)){
        return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : [];
    }else if(sessionStorage.getItem(key)){
        return JSON.parse(sessionStorage.getItem(key))
    }else if(Cookies.get(key)){
        return JSON.parse(Cookies.get(key))
    }
    
}

export function setStorage(key, val, storage = 'cookie', cookieExpires = 1) {
    // 如果是字符串，直接存储原始值；其他类型（如对象、数组）才调用 JSON.stringify
    const valueToStore = typeof val === 'string' ? val : JSON.stringify(val);
    
    if (storage === 'local') {
        localStorage.setItem(key, valueToStore);
    } else if (storage === 'session') {
        sessionStorage.setItem(key, valueToStore);
    } else {
        if (cookieExpires == 0) {
            const now = new Date();
            cookieExpires = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate() + 1
            ) - now;
            cookieExpires = cookieExpires / (1000 * 60 * 60 * 24);
        }
        Cookies.set(key, valueToStore, { expires: cookieExpires });
    }
}

export function removeStorage(key)
{
    if(localStorage.getItem(key)){
        return localStorage.removeItem(key)
    }else if(sessionStorage.getItem(key)){
        return sessionStorage.removeItem(key)
    }else if(Cookies.get(key)){
        return Cookies.remove(key)
    }
}
